import { Language, I18nType } from "@zkt/eb-utility";

export const texts = {
  [Language.EN_US]: {
    helperCenter: "Helper Center",
    feedbacks: "Feedbacks",
    systemMessages: "System Messages",
    setDefault: "select as default",
    default: "default",
    selectHotel: "Select The Hotel To Switch",
    modifyPassword: "Modify Password",
    modifyAccountInfo: "Modify Account",
    switchOldVersion: "Switch To Old Version",
    signout: "Sign Out",
    hotelNamePlaceholer: "Please enter hotelName or hotelId to search",
    switchToJfk: "Switch To JFK",
    switchHotel: "Switch Hotel",
  },
  [Language.ZH_CN]: {
    helperCenter: "帮助中心",
    feedbacks: "反馈意见",
    systemMessages: "系统消息",
    setDefault: "设为默认",
    default: "默认",
    selectHotel: "选择要切换的酒店",
    modifyPassword: "修改密码",
    modifyAccountInfo: "设置",
    switchOldVersion: "返回旧版",
    signout: "退出",
    hotelNamePlaceholer: "请输入商户名称/ID/所在城市",
    switchToJfk: "访问金房卡系统",
    switchHotel: "切换",
  },
};

export type I18nTextType = I18nType<typeof texts>;
